import { Autoplay, Keyboard, Mousewheel, Navigation } from "swiper/modules";
import {
  listenForVariantImageUpdateEvent,
  listenForVariantOptionsChanges,
} from "@surf-turf/nemo/assets/utils-events";
import Swiper from "swiper";
import { getSelectedValueByFieldsetElementOrNull } from "@surf-turf/nemo/assets/utils-product";

class ProductMedia extends HTMLElement {
  constructor() {
    super();

    const productMediaElement = this;
    const productmMediaInnerElement = productMediaElement.querySelector(
      ".product-media__inner"
    );
    const swiperHolder = productMediaElement.querySelector(".swiper");
    const enableLoop = productMediaElement.getAttribute("data-loop");
    const enableAutoplay = productMediaElement.getAttribute("data-autoplay");
    const autoplaySpeed = productMediaElement.getAttribute(
      "data-autoplay-speed"
    );
    const enableKeyboard = productMediaElement.getAttribute("data-keyboard");
    const productForm = document.querySelector("product-form");
    const mediaSlider = productMediaElement.querySelector(".swiper-wrapper");
    const allVariantMediaJson = productForm.querySelector(
      ".variant-image-data"
    );
    const allVariantMediaData = allVariantMediaJson
      ? JSON.parse(allVariantMediaJson.innerHTML).variants
      : null;
    const mobileBreakpoint = 320;
    const desktopBreakpoint = 640;
    const swiperConfig = {
      modules: [Mousewheel, Navigation],
      mousewheel: {
        forceToAxis: true,
      },
      direction: "horizontal",
      threshold: 10,
      edgeSwipeDetection: true,
      breakpoints: {
        // when window width is >= 320px
        [mobileBreakpoint]: {
          slidesPerView: "auto",
        },
        // when window width is >= 480px
        [desktopBreakpoint]: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
      },
    };

    if (enableAutoplay && enableAutoplay === "true") {
      swiperConfig.modules = swiperConfig.modules
        ? [...swiperConfig.modules, Autoplay]
        : [Autoplay];
    }

    if (enableLoop && enableLoop === "true") {
      swiperConfig.loop = true;
    }

    if (autoplaySpeed && autoplaySpeed > 0) {
      swiperConfig.autoplay = {
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
        delay: autoplaySpeed,
      };
    }

    if (enableKeyboard && enableKeyboard === "true") {
      swiperConfig.modules = swiperConfig.modules
        ? [...swiperConfig.modules, Keyboard]
        : [Keyboard];
      swiperConfig.keyboard = {
        enabled: true,
      };
    }

    const areValuesTheSame = (value1, value2) => value1 === value2;

    /**
     * Update variant label.
     */
    const updateVariantLabel = () => {
      const allVariantLabelElement =
        productMediaElement.querySelectorAll(".variant-label");
      let mainProductName = null;
      const allVariantLabelElementArray = [...allVariantLabelElement];
      let mainProductCollection =
        allVariantLabelElementArray[0]?.dataset.mainProductCollection;
      if (allVariantLabelElement.length > 1) {
        mainProductName =
          allVariantLabelElementArray[0].dataset.mainProductName;
      }

      // Loop over connected products
      const allConnectedProductElements =
        productForm.querySelectorAll("connected-product");
      const allConnectedProductElementsArray = [...allConnectedProductElements];
      let newVariantLabelText = mainProductName;

      // console.log(allVariantLabelElementArray[4].dataset.mainProductName);

      allConnectedProductElementsArray.map((connectedProductElement) => {
        const sizeFieldsetElement = connectedProductElement.querySelector(
          ".property--size fieldset"
        );
        const selectedValue =
          getSelectedValueByFieldsetElementOrNull(sizeFieldsetElement);
        if (selectedValue === "none") {
          // Do nothing
        } else if (
          mainProductCollection === "Marquise Shapes" &&
          selectedValue === "one size"
        ) {
          newVariantLabelText += ` + Chain`;
        } else if (
          mainProductCollection === "Bracelets" &&
          selectedValue === "one size"
        ) {
          newVariantLabelText += ` + Clasp`;
        } else if (
          mainProductCollection === "Necklaces" &&
          selectedValue === "one size"
        ) {
          newVariantLabelText += ` + Chain`;
        } else if (
          mainProductCollection === "2-in-1" &&
          selectedValue === "one size"
        ) {
          newVariantLabelText += ` + Chain`;
        } else {
          newVariantLabelText += ` + ${selectedValue}`;
        }
      });

      allVariantLabelElementArray.map((variantLabelElement) => {
        variantLabelElement.innerHTML = newVariantLabelText;
      });

      const labelDropAhint = document.querySelector(
        ".drop-a-hint-variant-label"
      );
      labelDropAhint.innerHTML = newVariantLabelText;

      const labelforzoomcontainer = document.querySelector(
        ".labelforzoomcontainer"
      );
      labelforzoomcontainer.innerHTML = newVariantLabelText;
    };

    /**
     * Handle product images
     *
     * @param {string} variantId
     */
    const handleProductImages = (variantId) => {
      // Set loading state on the product media element.
      productMediaElement.classList.add("js-loading");
      const correctVariantObject = allVariantMediaData.find(
        (variant) => variant.id === variantId
      );

      if (!correctVariantObject) {
        return null;
      }

      // Loop over connected products
      const allConnectedProductElements =
        productForm.querySelectorAll("connected-product");
      const allConnectedProductElementsArray = [...allConnectedProductElements];

      const valuesOfConnectedProducts = allConnectedProductElementsArray.map(
        (connectedProductElement) => {
          const connectedProductId =
            connectedProductElement.dataset.connectedProduct;
          const connectedProductSizeFieldsetElement =
            connectedProductElement.querySelector(".property--size fieldset");
          let sizeValue = getSelectedValueByFieldsetElementOrNull(
            connectedProductSizeFieldsetElement
          );

          if (sizeValue === "one size") {
            sizeValue = "one_size";
          }

          // If connected product has an id. Look for this id and the value of the connected product in the correct variant object.
          if ((connectedProductId, sizeValue)) {
            return sizeValue;
          }
        }
      );

      // Get the quantity value if there is any quantity fieldset.
      const quanityFieldsetElement = productForm.querySelector(
        'fieldset[name="quantity"]'
      );
      const initialFieldsetElement = productForm.querySelector(
        'fieldset[name="initial"]'
      );
      const allVariantImageInSlider = [
        ...mediaSlider.querySelectorAll(".variant-image"),
      ];
      // Remove the previously set variant images.
      allVariantImageInSlider.map((variantImageElement) => {
        variantImageElement.classList.add("js-hidden");
        variantImageElement.classList.remove("js-visible-variant-image");
      });

      // Loog for variant image in the dom with the same variant id.
      const allVariantImagesWithSameVariantId = allVariantImageInSlider.filter(
        (variantImageElement) =>
          Number(variantImageElement.dataset.variantId) ===
          Number(correctVariantObject.id)
      );

      const allVariantImagesForCorrectTemplate =
        allVariantImagesWithSameVariantId.filter((variantImageElement) => {
          // Filter none + pair images on the altenrative templates
          const url = window.location.href;

          if (
            variantImageElement.dataset["quantity"] === "pair" &&
            url.search === "optional+necklace+-+color"
          ) {
            return false;
          } else {
            return true;
          }
        });

      // Filter the variant images with the same variant id to only have variant images with the same variant id AND the same connected product values.
      const allVariantImagesWithSameIdAndSameConnectedValues =
        allVariantImagesForCorrectTemplate.filter((variantImageElement) => {
          // Check if there are connected products and if the connected product value is not empty or a space or null.
          const connectedProduct1Value =
            variantImageElement.dataset["connectedProduct-1"];
          const connectedProduct2Value =
            variantImageElement.dataset["connectedProduct-2"];

          // Check if all the connected product values match the url values.
          if (
            connectedProduct1Value &&
            connectedProduct1Value.length > 1 &&
            connectedProduct1Value !== "null" &&
            connectedProduct2Value &&
            connectedProduct2Value.length > 1 &&
            connectedProduct2Value !== "null"
          ) {
            const valueFromImage1 = connectedProduct1Value;
            const valueFromImage2 = connectedProduct2Value;

            return (
              areValuesTheSame(valueFromImage1, valuesOfConnectedProducts[0]) &&
              areValuesTheSame(valueFromImage2, valuesOfConnectedProducts[1])
            );
          } else if (
            connectedProduct1Value &&
            connectedProduct1Value.length > 1 &&
            connectedProduct1Value !== "null"
          ) {
            // Check if only the first connected product value matches the url values.
            const valueFromImage = connectedProduct1Value;

            return areValuesTheSame(
              valueFromImage,
              valuesOfConnectedProducts[0]
            );
          } else if (
            connectedProduct2Value &&
            connectedProduct2Value.length > 1 &&
            connectedProduct2Value !== "null"
          ) {
            // Check if only the second connected product value matches the url values.
            const valueFromImage = connectedProduct2Value;

            return areValuesTheSame(
              valueFromImage,
              valuesOfConnectedProducts[1]
            );
          } else {
            // If there are no connected products let all images go trough
            return true;
          }
        });

      // If there is a quantity selected. Filter the images on quantity.
      const allVariantImagesWithCorrectQuantity =
        allVariantImagesWithSameIdAndSameConnectedValues.filter(
          (variantImageElement) => {
            if (quanityFieldsetElement) {
              const quantityValue = getSelectedValueByFieldsetElementOrNull(
                quanityFieldsetElement ? quanityFieldsetElement : null
              );
              if (variantImageElement.dataset.quantity) {
                const valueFromImage = variantImageElement.dataset.quantity;

                return valueFromImage === quantityValue;
              } else {
                return true;
              }
            } else {
              // Let everything trough when there is no quantity selector.
              return true;
            }
          }
        );

      // If there is a intial. Filter the images on initial.
      const allVariantImagesWithCorrectIntial =
        allVariantImagesWithCorrectQuantity.filter((variantImageElement) => {
          if (initialFieldsetElement) {
            const selectElement =
              initialFieldsetElement.querySelector("select");
            const selectedOption =
              selectElement.options[selectElement.selectedIndex];
            const initialValue = selectedOption?.value || null;

            if (variantImageElement.dataset.initial) {
              const valueFromImage = variantImageElement.dataset.initial;

              return valueFromImage === initialValue;
            } else {
              return true;
            }
          } else {
            // Let everything trough when there is no initial selector.
            return true;
          }
        });

      const arrayOfAllVAriantImageElements = [
        ...allVariantImagesWithCorrectIntial,
      ];

      arrayOfAllVAriantImageElements.map((variantImageElement) => {
        const variantImageElementUrlHolder =
          variantImageElement.querySelector("img");
        const variantImageElementUrl = variantImageElementUrlHolder
          ? variantImageElementUrlHolder.getAttribute("src")
          : null;
        const finalImageUrl = variantImageElementUrl
          ? variantImageElementUrl.replace("resize=500", "resize=1445")
          : null;

        // Show the lower resolution image first.
        variantImageElement.classList.remove("js-hidden");

        variantImageElement.classList.add("js-visible-variant-image");

        // Load the high resolution image in the background with JS and replace the lower resolution image after loading.
        const targetImage = new Image();

        targetImage.src = finalImageUrl;
        targetImage.onload = () => {
          variantImageElementUrlHolder.replaceWith(targetImage);
        };
      });

      const allSlides = swiperHolder.querySelectorAll(
        ".swiper-slide:not(.js-hidden)"
      );

      if (swiperHolder.classList.contains("first-slide-active")) {
        allSlides.forEach((slideElement, index) => {
          if (index === 0) {
            slideElement.style.maxWidth = "var(--first-slide-width)";
          }
        });
      }

      const swiper = new Swiper(swiperHolder, swiperConfig);

      if (matchMedia("screen and (min-width: 768px)").matches) {
        swiper.destroy();
      } else {
        swiper.on("sliderFirstMove", () => {
          const allSlides = swiperHolder.querySelectorAll(".swiper-slide");

          if (swiper.touches.diff < 0) {
            setTimeout(() => {
              allSlides.forEach((slideElement) => {
                slideElement.style.maxWidth = "100%";
                slideElement.style.transition = "all 0s ease";
              });

              swiper.update();
            }, 300);
          }

          swiperHolder.classList.remove("first-slide-active");
        });
      }

      window.addEventListener("resize", () => {
        if (matchMedia("screen and (min-width: 768px)").matches) {
          swiper.destroy();
        } else {
        }
      });

      window.addEventListener(
        "shopify:section:load",
        () => new Swiper(swiperHolder, swiperConfig)
      );

      // Remove loading state.
      productMediaElement.classList.remove("js-loading");
      productmMediaInnerElement.style.opacity = 1;
    };

    updateVariantLabel();

    listenForVariantOptionsChanges(() => {
      updateVariantLabel();
    });

    // If there are no variant images. Remove the loading state.
    if (allVariantMediaData.length == 1) {
      setTimeout(() => {
        productMediaElement.classList.remove("js-loading");
        productmMediaInnerElement.style.opacity = 1;

        const allSlides = swiperHolder.querySelectorAll(
          ".swiper-slide:not(.js-hidden)"
        );

        if (swiperHolder.classList.contains("first-slide-active")) {
          allSlides.forEach((slideElement, index) => {
            if (index === 0) {
              slideElement.style.maxWidth = "var(--first-slide-width)";
            }
          });
        }

        const swiper = new Swiper(swiperHolder, swiperConfig);

        if (matchMedia("screen and (min-width: 768px)").matches) {
          swiper.destroy();
        } else {
          swiper.on("sliderFirstMove", () => {
            const allSlides = swiperHolder.querySelectorAll(".swiper-slide");

            if (swiper.touches.diff < 0) {
              setTimeout(() => {
                allSlides.forEach((slideElement) => {
                  slideElement.style.maxWidth = "100%";
                  slideElement.style.transition = "all 0s ease";
                });

                swiper.update();
              }, 300);
            }

            swiperHolder.classList.remove("first-slide-active");
          });
        }

        window.addEventListener("resize", () => {
          if (matchMedia("screen and (min-width: 768px)").matches) {
            swiper.destroy();
          } else {
          }
        });

        window.addEventListener(
          "shopify:section:load",
          () => new Swiper(swiperHolder, swiperConfig)
        );
      }, 500);
    }

    listenForVariantImageUpdateEvent((event) => {
      const variantId = event.detail?.value;

      handleProductImages(Number(variantId));
    });

    const slideElements = productMediaElement.querySelectorAll(".swiper-slide");

    slideElements.forEach((slideElement) => {
      slideElement.addEventListener("click", () => {
        // Create a custom event
        const customEvent = new CustomEvent("openLightbox", {
          detail: {
            deeplinkTarget: slideElement.dataset.deeplinkTarget, // Pass the target to identify the specific content
          },
        });

        // Dispatch the custom event to signal the "Lightbox" component to open the lightbox
        document.dispatchEvent(customEvent);
      });
    });
  }
}

// Check if element is defined, if not define it..
// eslint-disable-next-line no-undefined
if (customElements.get("product-media") === undefined) {
  customElements.define("product-media", ProductMedia);
}
